import * as React from "react";

import { Button, Form, Modal } from "semantic-ui-react";

import { useForm, FormProvider } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";

import { SemanticReactHookFormsInput } from "@teamprevent/common/forms/SemanticReactHookFormsInput";
import { SemanticReactHookFormsDropdown } from "@teamprevent/common/forms/SemanticReactHookFormsDropdown";

import { useSelector } from "react-redux";

import { useDispatch } from "@teamprevent/admin-redux";

import { PartialCustomerListModel, loadCustomers } from "../../crud/customer";
import { AccessGroupFormModel, accessGroupSchemaFactory } from "../schema";
import { AccessGroupApi } from "../accessGroupsApi";
import { customersSelector } from "../../crud/customer/selectors";

interface OwnProps {
    open: boolean;
    closeModal: () => void;
}

export const CreateModal: React.FunctionComponent<OwnProps> = (props: OwnProps) => {
    const dispatch = useDispatch();
    const { open, closeModal } = props;
    const customers: PartialCustomerListModel[] = useSelector(customersSelector);

    const { handleSubmit, reset, register, control, ...methods } = useForm<AccessGroupFormModel>({
        resolver: zodResolver(accessGroupSchemaFactory()),
        shouldFocusError: true,
        mode: "onBlur"
    });

    const close = React.useCallback(() => {
        reset();
        closeModal();
    }, [closeModal, reset]);

    const save = React.useCallback(async (model: AccessGroupFormModel) => {
        await AccessGroupApi.create(model);
        close();
    }, [close]);

    React.useEffect(() => {
        dispatch(loadCustomers());
    }, [dispatch]);

    return (
        <Modal as={Form} size="small" open={open} onClose={close} onSubmit={handleSubmit(save)} closeOnDimmerClick={false}>
            <FormProvider handleSubmit={handleSubmit} reset={reset} register={register} control={control} {...methods}>
                <Modal.Header>Create Access Group</Modal.Header>
                <Modal.Content>
                    <SemanticReactHookFormsInput
                        label="Group Name"
                        control={control}
                        name="name"
                    />
                    <SemanticReactHookFormsInput
                        label="Object ID"
                        control={control}
                        name="id"
                    />
                    <SemanticReactHookFormsDropdown
                        label="Customers"
                        control={control}
                        name="customerIds"
                        options={customers.map(customer => ({ value: customer.id, text: customer.name }))}
                        search
                        multiple
                    />
                    <Form.Field>
                        <label>Active</label>
                        <input type="checkbox" {...register("active")} />
                    </Form.Field>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={close}>Cancel</Button>
                    <Button content="Save" type="submit" />
                </Modal.Actions>
            </FormProvider>
        </Modal>
    );
};
